import { useEffect, useRef } from 'react';

export function useInactivity(timeoutMs: number, onInactive: (val: boolean)=>void, applyHook: boolean) {
    const timerRef: any = useRef()
    useEffect(() => {
        if(applyHook){

            const events = [
                'mousedown',
                'keydown',
                'scroll',
                'touchstart',
            ]
    
            const resetTimer = () => {
                clearTimeout(timerRef.current)
                
                timerRef.current = setTimeout(() => {
                    onInactive(true)
                }, timeoutMs)
            }
    
            events.forEach(event =>
                window.addEventListener(event, resetTimer)
            )
    
            resetTimer()
    
            return () => {
                clearTimeout(timerRef.current)
    
                events.forEach(event =>
                    window.removeEventListener(event, resetTimer)
                )
            }
        }
    }, [timeoutMs, onInactive, applyHook])
}